import React from 'react';

import {
  ReportTrailsToolbar,
  ReportTrailsList,
} from 'views/Reports/Trails/components';
import { useStyles } from './styles';
import ReportData, { AdminReportType } from 'services/dataService/ReportData';
import TRAILReportJSON from 'constants/JSONConstants/trail-report-table-columns';
import { useTranslation } from 'react-i18next';
import { CustomFieldsData } from 'services/dataService';


export default () => {
  const classes = useStyles();
  const [fields, setFields] = React.useState([]);
  const { t } = useTranslation(['tables']);
  const [loading, setLoading] = React.useState(true);

  const loadFields = async () => {
    try {      
      const { data: reportFields } = await ReportData.getReportFields(
        AdminReportType.TRAIL
      );
      
      const { data: customFields } = await CustomFieldsData.getCustomFields();
      const customfieldsArray = JSON.parse(customFields?.custom_fields || '[]');

      let reportData = [];
      let serverText = false;

      if (reportFields?.table_titles?.length) {
        reportData = reportFields?.table_titles;
      } else {
        reportData = TRAILReportJSON;
        reportData = reportData.concat(
          customfieldsArray?.map((field) => {
            return {
              title: field?.fieldName,
              field: field?.fieldName,
              type: field?.type,
              selected: false,
            };
          }) || []
        );
      }
      
      setFields(
        reportData.map(({ title, field, selected, type }) => {          
          return {
            title: serverText ? title : t(title),
            field,
            hidden: !selected,
            type,
          };     
      })
      );
    } catch (error) {
      setFields(
        TRAILReportJSON.map(({ title, field, selected, type }) => {
          return { title: t(title), field, hidden: !selected, type };
        })
      );
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    loadFields();
  }, []);


  return (
    <div className={classes.root}>
      {!loading && (
        <>
          <ReportTrailsToolbar
            fields={fields}
            onSave={async (selectedList) => {
              await ReportData.updateFields({
                type: AdminReportType.TRAIL,
                table_titles: selectedList,
              });

              loadFields();
            }}
          />
          <div className={classes.content}>
            <ReportTrailsList fields={fields} />
          </div>
        </>
      )}
    </div>
  );
};
